/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

//@todo this is dumb

export class EnvUtils {
  private static environment = process.env.ENVIRONMENT;

  public static getTopLevelDomain = (): string => {
    switch (EnvUtils.environment) {
      case "dev":
        return "https://viennahypertest.com";
      case "local":
        return "http://localhost:8080";
      case "prod":
        return "https://vienna.earth";
    }
  };
}
